import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {scheduleTrackingTask} from "../../../../tracking/utils/schedule_tracking_task";
import {IPricesHubHeroCity} from "../../hooks/use_prices_hub_hero_cities";
import {PRICES_HUB_ANALYTICS_LOCATION} from "../../tracking/prices_hub_analytics";
import {trackPricesSearch} from "../../tracking/track_prices_search";
import {formatPriceM2, formatSignedPercent} from "../../utils/format_price_m2";
import {getCityLink} from "../../utils/get_city_link";
import {PricesHubCityIcon} from "./PricesHubCityIcon";
import {PricesHubTrendChip} from "./PricesHubTrendChip";

interface IProps {
    city: IPricesHubHeroCity;
}

export const PricesHubHeroCityCard = (props: IProps) => {
    const {city} = props;

    return (
        <a
            className={cardStyle}
            href={getCityLink(city.slug)}
            title={`Ceny mieszkań – ${city.name}`}
            onClick={() =>
                scheduleTrackingTask(() =>
                    trackPricesSearch({location: PRICES_HUB_ANALYTICS_LOCATION, searchQuery: city.name, searchMethod: "popular_search_click"})
                )
            }
        >
            <PricesHubCityIcon slug={city.slug} size="4.4" tone="light" className={iconStyle} />

            <span className={copyStyle}>
                <span className={titleRowStyle}>
                    <Text as="span" variant="body_copy_1" className={nameStyle}>
                        {city.name}
                    </Text>

                    {city.yearToYearPercent !== null ? (
                        <PricesHubTrendChip size="compact" isBelow={city.yearToYearPercent < 0} hiddenLabel="zmiana ceny rok do roku:">
                            {formatSignedPercent(city.yearToYearPercent)}
                            {/* The hidden label already reads "rok do roku" to screen readers - "r/r" is its visual shorthand. */}
                            <span aria-hidden="true" className={yearToYearSuffixStyle}>
                                r/r
                            </span>
                        </PricesHubTrendChip>
                    ) : null}
                </span>

                <Text as="span" variant="info_txt_1" className={priceStyle}>
                    śr. {formatPriceM2(city.avgPriceM2)}
                </Text>
            </span>
        </a>
    );
};

const cardStyle = css({
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    boxSizing: "border-box",
    width: "100%",
    height: "7.2rem",
    pl: 2,
    pr: "1.4rem",
    py: "1.4rem",
    color: "var(--colors-white)",
    backgroundColor: "rgba(35, 35, 45, 0.7)",
    borderRadius: "1.2rem",
    backdropFilter: "blur(4px)",
    textDecoration: "none",
    transition: "background-color 160ms ease",

    _hover: {
        color: "var(--colors-white)",
        backgroundColor: "rgba(35, 35, 45, 0.84)",
        textDecoration: "none"
    },

    _focusVisible: {
        outline: "2px solid var(--colors-primary)",
        outlineOffset: "2px"
    }
});

const iconStyle = css({
    color: "var(--colors-white)"
});

const copyStyle = css({
    display: "flex",
    flexDirection: "column",
    flex: "1 1 0",
    gap: "0.3rem",
    minWidth: 0
});

const titleRowStyle = css({
    display: "flex",
    alignItems: "center",
    gap: "0.6rem",
    minWidth: 0
});

// A size smaller than the percent, so "Warszawa +10,6% r/r" still fits the ~24rem desktop card.
const yearToYearSuffixStyle = css({
    marginLeft: "0.2rem",
    fontSize: "0.8em"
});

const nameStyle = css({
    overflow: "hidden",
    color: "var(--colors-white)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});

const priceStyle = css({
    color: "var(--colors-white)",
    whiteSpace: "nowrap"
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {scheduleTrackingTask} from "../../../../tracking/utils/schedule_tracking_task";
import {IPricesHubHeroCity} from "../../hooks/use_prices_hub_hero_cities";
import {PRICES_HUB_ANALYTICS_LOCATION} from "../../tracking/prices_hub_analytics";
import {trackPricesSearch} from "../../tracking/track_prices_search";
import {formatPriceM2, formatSignedPercent} from "../../utils/format_price_m2";
import {getCityLink} from "../../utils/get_city_link";
import {PricesHubCityIcon} from "./PricesHubCityIcon";
import {PricesHubTrendChip} from "./PricesHubTrendChip";

interface IProps {
    city: IPricesHubHeroCity;
}

export const PricesHubHeroCityCard = (props: IProps) => {
    const {city} = props;

    return (
        <a
            className={cardStyle}
            href={getCityLink(city.slug)}
            title={`Ceny mieszkań – ${city.name}`}
            onClick={() =>
                scheduleTrackingTask(() =>
                    trackPricesSearch({location: PRICES_HUB_ANALYTICS_LOCATION, searchQuery: city.name, searchMethod: "popular_search_click"})
                )
            }
        >
            <PricesHubCityIcon slug={city.slug} size="4.4" tone="light" className={iconStyle} />

            <span className={copyStyle}>
                <span className={titleRowStyle}>
                    <Text as="span" variant="body_copy_1" className={nameStyle}>
                        {city.name}
                    </Text>

                    {city.yearToYearPercent !== null ? (
                        <PricesHubTrendChip size="compact" isBelow={city.yearToYearPercent < 0} hiddenLabel="zmiana ceny rok do roku:">
                            {formatSignedPercent(city.yearToYearPercent)}
                            {/* The hidden label already reads "rok do roku" to screen readers - "r/r" is its visual shorthand. */}
                            <span aria-hidden="true" className={yearToYearSuffixStyle}>
                                r/r
                            </span>
                        </PricesHubTrendChip>
                    ) : null}
                </span>

                <Text as="span" variant="info_txt_1" className={priceStyle}>
                    śr. {formatPriceM2(city.avgPriceM2)}
                </Text>
            </span>
        </a>
    );
};

const cardStyle = css({
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    boxSizing: "border-box",
    width: "100%",
    height: "7.2rem",
    pl: 2,
    pr: "1.4rem",
    py: "1.4rem",
    color: "var(--colors-white)",
    backgroundColor: "rgba(35, 35, 45, 0.7)",
    borderRadius: "1.2rem",
    backdropFilter: "blur(4px)",
    textDecoration: "none",
    transition: "background-color 160ms ease",

    _hover: {
        color: "var(--colors-white)",
        backgroundColor: "rgba(35, 35, 45, 0.84)",
        textDecoration: "none"
    },

    _focusVisible: {
        outline: "2px solid var(--colors-primary)",
        outlineOffset: "2px"
    }
});

const iconStyle = css({
    color: "var(--colors-white)"
});

const copyStyle = css({
    display: "flex",
    flexDirection: "column",
    flex: "1 1 0",
    gap: "0.3rem",
    minWidth: 0
});

const titleRowStyle = css({
    display: "flex",
    alignItems: "center",
    gap: "0.6rem",
    minWidth: 0
});

// A size smaller than the percent, so "Warszawa +10,6% r/r" still fits the ~24rem desktop card.
const yearToYearSuffixStyle = css({
    marginLeft: "0.2rem",
    fontSize: "0.8em"
});

const nameStyle = css({
    overflow: "hidden",
    color: "var(--colors-white)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});

const priceStyle = css({
    color: "var(--colors-white)",
    whiteSpace: "nowrap"
});
